import { X } from "lucide-react";
import { scrollToId } from "@/lib/scroll";

export const PromoBanner = ({ promo = {}, onClose }) => {
  const isUrl = promo.linkTarget && /^https?:\/\//i.test(promo.linkTarget);
  const hasLink = promo.linkLabel && promo.linkTarget;

  const handleLink = (e) => {
    if (!isUrl) {
      e.preventDefault();
      scrollToId(promo.linkTarget);
    }
  };

  return (
    <div
      className="fixed inset-x-0 top-0 z-[60] flex h-10 items-center justify-center gap-3 bg-accent px-4 text-center text-sm font-medium text-accent-foreground"
      data-testid="promo-banner"
    >
      <p className="truncate">
        {promo.text}
        {hasLink ? (
          <a
            href={isUrl ? promo.linkTarget : `#${promo.linkTarget}`}
            onClick={handleLink}
            className="ml-2 inline-flex items-center font-semibold underline underline-offset-2 hover:opacity-90"
            target={isUrl ? "_blank" : undefined}
            rel={isUrl ? "noopener noreferrer" : undefined}
            data-testid="promo-banner-link"
          >
            {promo.linkLabel}
          </a>
        ) : null}
      </p>
      <button
        onClick={onClose}
        className="absolute right-2 top-1/2 flex h-6 w-6 -translate-y-1/2 items-center justify-center rounded-full text-accent-foreground/80 transition-colors hover:bg-black/10 hover:text-accent-foreground"
        aria-label="Isara ang banner"
        data-testid="promo-banner-close"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
};
